var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSecurityCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9982 1.83398C8.24106 1.83398 6.45334 3.68473 4.33907 4.35931C3.4794 4.6336 3.04956 4.77075 2.8756 4.96408C2.70165 5.15741 2.65071 5.43992 2.54883 6.00494C1.45865 12.0511 3.84149 17.641 9.52427 19.8167C10.1349 20.0504 10.4401 20.1673 11.0012 20.1673C11.5622 20.1673 11.8675 20.0504 12.4781 19.8167C18.1605 17.6409 20.5411 12.0511 19.4506 6.00493C19.3486 5.43982 19.2977 5.15726 19.1237 4.96393C18.9497 4.7706 18.5199 4.63353 17.6603 4.35939C15.5452 3.68487 13.7554 1.83398 10.9982 1.83398Z",
    stroke: "#2177FE",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.24976 11.9176C8.24976 11.9176 9.16642 11.9176 10.0831 13.751C10.0831 13.751 12.9949 9.16764 15.5831 8.25098",
    stroke: "#2177FE",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurityCheck);
export default __webpack_public_path__ + "static/media/security-check.f32836184d52aad834f13e06c5ba7674.svg";
export { ForwardRef as ReactComponent };